import { http } from 'services';

// ## Admin - List Instances
// curl "http://192.168.0.15:3000/admin/instances?group_by=type&include=owner,logo,instance_data,last_active_plan"
export function getAdminInstances(query, cbSuccess, cbError) {
  http.get(
    'admin/instances',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Admin - Get Instance by ID
// curl "http://192.168.0.15:3000/admin/instances/12"
export function getAdminInstanceDetails(instanceID, cbSuccess, cbError) {
  http.get(
    `admin/instances/${instanceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function setAdminInstanceBlock(instanceID, payload, cbSuccess, cbError) {
  http.post(
    `admin/instances/${instanceID}/block`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getAdminInstanceSubscriptions(instanceID, query, cbSuccess, cbError) {
  http.get(
    `admin/instances/${instanceID}/subscriptions`,
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getAdminInstanceSubscriptionDetails(instanceID, subscriptionID, cbSuccess, cbError) {
  http.get(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getAdminInstanceSubscriptionInvoices(instanceID, subscriptionID, cbSuccess, cbError) {
  http.get(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}/invoices`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getAdminInstanceSubscriptionInvoiceDetails(instanceID, subscriptionID, invoiceID, cbSuccess, cbError) {
  http.get(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}/invoices/${invoiceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function setAdminInstanceSubscriptionInvoiceConfirmPayment(instanceID, subscriptionID, invoiceID, payload, cbSuccess, cbError) {
  http.post(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}/invoices/${invoiceID}/confirm-payment`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function setAdminInstanceSubscriptionInvoiceDenyPayment(instanceID, subscriptionID, invoiceID, payload, cbSuccess, cbError) {
  http.post(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}/invoices/${invoiceID}/deny-payment`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function setAdminInstanceSubscriptionInvoiceCancelPayment(instanceID, subscriptionID, invoiceID, payload, cbSuccess, cbError) {
  http.post(
    `admin/instances/${instanceID}/subscriptions/${subscriptionID}/invoices/${invoiceID}/cancel-payment`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}




// WEBPACK FOOTER //
// ./src/api/api-system-administration/api-system-administration-base.js